import { useCallback, useEffect, useRef, useState } from "react";
import { useEvent } from "@/context/AppContext";
import { api } from "@/lib/api";

// Profiles loaded once; counters/status follow realtime events; the list is re-read only when it really changes (debounced, also after a reconnect).
export function useLiveAccounts() {
  const [accs, setAccs] = useState([]);
  const t = useRef(null);
  const load = useCallback(() => api.get("/telegram/accounts").then((r) => setAccs(r.data)).catch(() => {}), []);
  const soon = useCallback(() => { clearTimeout(t.current); t.current = setTimeout(load, 600); }, [load]);
  useEffect(() => { load(); return () => clearTimeout(t.current); }, [load]);
  useEvent("UNREAD_COUNTERS", (d) => setAccs((p) => p.map((a) => (a.id === d.account_id ? { ...a, unread: d.unread, unread_conversations: d.unread_conversations } : a))));
  useEvent("account.status", (d) => setAccs((p) => p.map((a) => (a.id === d.account_id ? { ...a, status: d.status, ...(d.gap !== undefined ? { updates_gap: d.gap } : {}) } : a))));
  useEvent("MESSAGES_ACCOUNT_LIST_UPDATED", soon);
  return accs;
}
